import {html} from "lit-element";

// language=HTML
export const style = (colors) => html`
<style>
        :host {
             display: block;
      
            --app-primary: ${colors.appPrimary};
            --app-lightgrey: ${colors.appLightgrey};
            --app-grey: ${colors.appGrey};
            --app-darkgrey: ${colors.appDarkgrey};
            --app-white: ${colors.appWhite};
            
            --app-accent: ${colors.appAccent};
            --app-accent-light: ${colors.appAccentLight};
            --app-secondary-accent: ${colors.appSecondaryAccent};
            --app-third-accent: ${colors.appThirdAccent};

            --app-red: ${colors.appRed};
            --app-error: ${colors.appError};
            
            --app-success: ${colors.appSuccess};
            --app-green: ${colors.appGreen};
            --auth-text-color: ${colors.authTexColor};
            --auth-bg-color: ${colors.authBgColor};
            --auth-button-color: ${colors.authButtonColor};
            --auth-button-br-color:${colors.authButtonBrColor};
            --auth-button-bg-color: ${colors.authButtonBgColor};

            --app-header-background: ${colors.appHeaderBackground};

            --sidebar-bg: ${colors.sidebarBg};
            --sidebar-primary:${colors.sidebarPrimary};
            --sidebar-accent: ${colors.sidebarAccent};
            
            --background-color: ${colors.backgroundColor};
            --shadow-color: ${colors.shadowColor};
            
             min-height: 100vh;
             background-color: var(--background-color);
             
             --banner-radius-right: 0;
             --banner-radius-left: 0;
             
        }
        
        icon {
            width: 20px;
        }
        
        .toggle-button > icon {
            line-height: 50px;
        }

        icon svg {
            fill: #BCBCCB;
        }
        
        .toggle-element {
          box-shadow: 0 2px 6px rgba(12, 13, 14, 0.04), 0 0 0 transparent, 0 0 0 transparent, 0 0 0 transparent;
        }
     
        .app-title {
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            padding: 10px 20px;
            width: calc(33.3% - 40px);
        }
       
        .app-label {
            color: #BCBCCB;
            display: block;
        }
        
        .toggle-button:hover > icon > svg,
        .app-title:hover .app-label,
        .app-title:hover icon svg {
            fill: var(--app-accent);
            color: var(--app-accent);
        }
        
        .toggle-element.active {
            min-width: 400px;
        }
        
        #logo {
            height: 70px;
        }
        
        .logo-container {
            display: block;
            min-width: 75px;
            max-width: 75px;
            height: 75px;
            background-color: #FFFFFF;
            padding: 50px;
            border-radius: 0 50% 50% 50%;
        }
        
        .sw-header {
            z-index: 2;
            width: 100%;
            text-align: center;
            height: 70px;
            background-color: var(--app-header-background);
        }

        .main-container {
            height: 100vh;
        }
        
        /* Workaround for IE11 displaying <main> as inline */
        main {
            display: block;
        }
     
        main > * {
          display: none;
        }
        
        main > [active] {
            display: block;
            overflow: auto;
            height: 100vh;
        }
        
        a, p, div, span, strong {
          color: var(--app-primary);
        }
        
        a {
          text-decoration: none;
          cursor: pointer;
        }
      
        
        .transition {
          -moz-transition: all 200ms ease-in-out;
          -webkit-transition: all 200ms ease-in-out;
          -o-transition: all 200ms ease-in-out;
          transition: all 200ms ease-in-out;
        }
        
        .no-margin {
          margin: 0;
        }
     
      footer {
        text-align: center;
        margin-top: 20px;
        line-height: 24px;
        
        background-color: #FFF;
        border-radius: 75px 0 0 75px;
        height: 150px;
        width: 80%;
        margin-left: auto;
      }
      footer > a {
        color: var(--app-secondary-color);
        text-decoration: none;
      }
      footer > a:hover {
        text-decoration: underline;
      }
      
    
      
    @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px)  {
        .side-menu {
            display: none!important;
        }
    }
    
    /* Portrait and Landscape */
    @media only screen 
    and (min-width: 1024px) 
    and (max-height: 1366px) 
    and (-webkit-min-device-pixel-ratio: 1.5) {
       .side-menu {
            display: none!important;
        }
      
    }
</style>
`;
